import React, { Component } from 'react';
import { Checkbox } from 'react-bootstrap';
import './CheckboxSimple.scss';

/**A checkbox not linked to a redux field */
export default class CheckboxSimple extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: props.initialValue ? props.initialValue : false,
    };
  }

  componentDidMount() {
    const { initialState } = this.props;
    this.setState({
      checked: initialState ? initialState : false,
    });
  }

  toggleCheck() {
    const { handleChange } = this.props;
    const { checked } = this.state;
    this.setState({
      checked: !checked,
    });
    handleChange(!checked);
  }

  render() {
    const { inline } = this.props;
    const { checked } = this.state;

    return (
      <Checkbox
        className="simple-checkbox"
        onChange={() => this.toggleCheck()}
        checked={checked}
        inline={inline}
      >
        <span />
      </Checkbox>
    );
  }
}
